namespace Ir.Components.Workbook.TitleBar {
    interface ITitleBarViewModel {
        titleToolbarConfig: any,
    }
    
    export function getViewModel(this: ITitleBarViewModel, params: any) {
        let self = this;
        let config = params.config as WorkbookConfig;
        
        let userDetails = config.userDetails;

        let $optionsDropdownButton = $(`<div class="dropdowntoolbar"></div>`);
        let dropdownConfig = {
            items: [
                {
                    hint: "Administration Page",
                    title: " Administration",
                    icon: "admin_panel_settings",
                    iconClass: "ms",
                    visible: loggedUser.enableAdmin(),
                    onClick(e) {
                        workbook.workbookConfig.workbookHelper.goToURL("/admin", "Administration Page");
                    },
                },
                {
                    hint: "Formatting Rules",
                    title: " Formatting Rules",
                    icon: "colors",
                    iconClass: "ms",
                    visible: loggedUser.permissions.formattingRules() || loggedUser.permissions.editFormattingRules(),
                    onClick(e) {
                        FormattingRuleService.showEditor();
                    }
                },
                {
                    hint: "PDF Templates",
                    title: " PDF Templates",
                    icon: "format_image_left",
                    iconClass: "ms",
                    visible: loggedUser.permissions.editPDFTemplates() || loggedUser.permissions.pdfTemplates(),
                    onClick(e) {
                        Ir.Components.PDFTemplate.PDFTemplateEditor.show();
                    }
                },
                {
                    hint: "Emails Management",
                    title: " Emails Management",
                    icon: "inbox_customize",
                    iconClass: "ms",
                    visible: loggedUser.permissions.emailsManagement(),
                    onClick(e) {
                        Ir.Components.Email.ScheduledEmailEditor.show(true);
                    }
                },
                {
                    hint: "Email Logs",
                    title: " Email Logs",
                    icon: "contact_mail",
                    iconClass: "ms",
                    visible: loggedUser.permissions.emailsManagement(),
                    onClick(e) {
                        Ir.Components.Email.EmailLog.show();
                    }
                },
            ],
            itemTemplate: titleTemplate,
            visible: loggedUser.permissions.editFormattingRules() ||
                loggedUser.permissions.formattingRules() ||
                loggedUser.permissions.editPDFTemplates() ||
                loggedUser.permissions.pdfTemplates() ||
                loggedUser.enableAdmin() || 
                loggedUser.permissions.emailsManagement(),
            stylingMode: 'text',
            //text: "Options",
            showArrowIcon: false,
            icon: "ms ir-options-icon",
            hint: "Other options",
            displayExpr: "title",
            width: 26,
            elementAttr: {
                class: "other-options-button",
            },
            dropDownOptions: {
                wrapperAttr: {
                    class: "workbook-tabs-panel dropdowntabs"
                },
                maxHeight: "80vh",
                width: 150,
            },
            fieldTemplate(value, fieldElement) {
                const result = $("<div class='custom-item'>");
                result
                    .dxTextBox({
                        value: value,
                        readOnly: true
                    });
                fieldElement.append(result);
            },
        };
        
        let $createWorkbookButton = $(`<div class="new-workbook"><create-workbook-toolbar params="buttonType: buttonType, height: height"></create-workbook-toolbar></div>`);
        ko.applyBindings({ buttonType: "success", height: 26, }, $("create-workbook-toolbar", $createWorkbookButton)[0]);

        $optionsDropdownButton.dxDropDownButton(dropdownConfig as any);

        let actionButtonsPosition = "after";

        self.titleToolbarConfig = {
            items: [
                {
                    location: 'before',
                    template: () => {
                        let $img = $(`<img class="logo" data-bind="attr: { src: appLogo, title: appTitle }">`);
                        $img.on("click", function () {
                            workbook.workbookConfig.workbookHelper.goToURL(`${urlConfigs.siteRoot}home/home`, "home");
                        });
                        ko.applyBindings(config.appBar, $img[0]);
                        return $img;
                    },
                },
                {
                    widget: 'dxButton',
                    location: 'before',
                    options: {
                        icon: 'menu',
                        stylingMode: 'text',
                        onClick() {
                            config.generalSettings.drawerWorkbookSideBars?.toggle();
                        },
                        elementAttr: {
                            class: "drawer-icon"
                        },
                    },
                    visible: true,
                },
                {
                    widget: 'dxButton',
                    location: actionButtonsPosition,
                    options: {
                        icon: 'warning',
                        stylingMode: 'text',
                        hint: "Show all issues that occurred",
                        onClick() {
                            Ir.Components.Workbook.ToolBar.ShowErrorsToolBar.show(ErrorTypeEnum.Workbook);
                        }
                    },
                    visible: ko.computed(function () {
                        return ErrorService.errors()?.length > 0;
                    })
                },
                {
                    location: 'before',
                    template: () => {
                        let $span = $(`<div class="customer-container"><img data-bind="attr: { src: customerLogo}, visible: isLogoVisible"><span class="customer" data-bind="text: customerName"></span></div>`);
                        ko.applyBindings(config.appBar, $span[0]);
                        return $span;
                    },
                    visible: !isMobile()
                },
                {
                    location: 'before',
                    template: () => {
                        let $span = $(`</img><span class="customer"> | </span><span class="company" data-bind="text: companyName"></span>`);
                        ko.applyBindings(config.appBar, $span[1]);
                        return $span;
                    },
                    visible: !isMobile() && config.appBar.multiTenant,
                },
                {
                    widget: 'dxButton',
                    location: 'before',
                    template: "<select-company-toolbar></select-company-toolbar>",
                    visible: !isMobile()
                },
                {
                    location: 'center',
                    template: () => {
                        let $div = $(`<div><rename-input params="
                            name: $data.name, 
                            editBackgroundColor: '#5e5e5e',
                            maxWidth: '800px',
                            readOnly: $data.readOnly, 
                            fontColor: $data.fontColor, 
                            inputWidthCSS: $data.inputWidthCSS, 
                            save: $data.save"></rename-input>
                        <i class="ms editWorkbookName" data-bind="visible: $data.edit.visible, click: $data.edit.onClick">edit</i></div>`);
                        let vm = {
                            name: config.appBar.centralTitle,
                            readOnly: ko.observable(true),
                            //fontColor: itemData.tab().tabConfig.fontColor, //#fff
                            inputWidthCSS: ko.observable(""),
                            save: function () {
                                let saved = true;
                                let o = {
                                    url: urlConfigs.tabs + "ChangeWorkbookName",
                                    data: {
                                        workbookId: workbook.workbookConfig.workbookId(),
                                        name: config.appBar.centralTitle()
                                    },
                                    dataType: "json",
                                    async: false
                                } as RequestServerParams;
                                o.successFunction = function (data) {
                                    if (data.duplicatedName) {
                                        DevExpress.ui.notify("Duplicated workbook name, please choose another name", "error");
                                        saved = false;
                                    }
                                    else {
                                        workbook.workbookConfig.workbookName = config.appBar.centralTitle();
                                        Ir.Components.Workbook.WorkbookSideTabs.updateWorkbookName(workbook.workbookConfig.workbookId(), workbook.workbookConfig.workbookName);
                                    }
                                };
                                o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
                                    saved = false;
                                    errorItem.userMessage = "Failed to change workbook name";
                                    irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
                                };
                                irGlobal.requestServer(o);

                                return saved;
                            },
                            edit: {
                                visible: ko.computed(function () {
                                    return workbook.workbookConfig.generalSettings.editing();
                                }),
                                onClick() {
                                    vm.readOnly(false);
                                    $("input", $div).select();
                                }
                            }
                        };
                        ko.applyBindings(vm, $div.get(0));

                        return $div;
                    },
                },
                {
                    location: actionButtonsPosition,
                    template: "<editing-buttons-toolbar></editing-buttons-toolbar>",
                    visible: !isMobile()
                },
                {
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        icon: 'ms ir-info-icon',
                        hint: "Show/Hide the hints",
                        stylingMode: 'text',
                        elementAttr: {
                            class: "intro-hint-button",
                        },
                        onClick() {
                           IntroService.showIntroHintsForEmptyWorkbook(true); 
                        },
                    },
                },
                {
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        icon: 'ms ir-live-help-icon',
                        hint: "Show the intro tour",
                        stylingMode: 'text',
                        elementAttr: {
                            class: "intro-help-button",
                        },
                        onClick() {
                            IntroService.showIntroList();
                        },
                    },
                },
                {
                    location: 'after',
                    template: () => {
                        return $optionsDropdownButton;
                    },
                    visible: !isMobile()
                },
                {
                    location: 'after',
                    template: () => {
                        return $createWorkbookButton;
                    },
                    visible: !isMobile()
                },
                {
                    location: 'after',
                    widget: 'dxMenu',
                    options: {
                        cssClass: "workbook-titlebar userLoginPopup",
                        items: [{
                            name: userDetails.userInitials,
                            items: [
                                {
                                    name: userDetails.username,
                                    html: '<span class="material-icons">person</span>',
                                },
                                {
                                    beginGroup: true,
                                    name: 'Profile: ' + userDetails.userProfile,
                                    html: '<span class="material-icons">badge</span>',
                                },
                                {
                                    name: 'Organization: ' + userDetails.userOrganization,
                                    html: '<span class="material-icons">corporate_fare</span>',
                                },
                                {
                                    name: 'Locale: ' + loggedUser.locale(),
                                    html: '<span class="material-icons">public</span>',
                                },
                                {
                                    name: 'Time Zone: ' + loggedUser.timeZone(),
                                    html: '<span class="material-icons">schedule</span>',
                                },
                                {
                                    beginGroup: true,
                                    name: 'Interactive Reporting',
                                    html: '<span class="material-icons">equalizer</span>',
                                },
                                {
                                    name: 'Version: ' + userDetails.version,
                                    html: '<span class="material-icons">info</span>',
                                },
                                {
                                    name: 'Date: ' + userDetails.date,
                                    html: '<span class="material-icons">description</span>',
                                },
                                {
                                    beginGroup: true,
                                    name: 'Change Password',
                                    html: '<span class="material-icons">password</span>',
                                    visible: authenticationMode === "IR",
                                },
                                {
                                    beginGroup: true,
                                    name: 'Logout',
                                    html: '<span class="material-icons">logout</span>',
                                },
                            ],
                        },],
                        hideSubmenuOnMouseLeave: false,
                        displayExpr: 'name',
                        onItemClick(data) {
                            switch (data.itemData.name) {
                                case "Change Password":
                                    irGlobal.changePassword();
                                    break;
                                case "Logout":
                                    if (workbook.workbookConfig.hasPendingChanges) {
                                        let customDialog = DevExpress.ui.dialog.custom({
                                            showTitle: false,
                                            messageHtml: `Are you sure you want to logout? You have pending changes to your workbook.`,
                                            buttons: [
                                                { text: "Yes", onClick: function () { return true } },
                                                { text: "No", onClick: function () { return false } }
                                            ]
                                        });
                                        customDialog.show().done(function (dialogResult) {
                                            if (dialogResult) {
                                                window.location.href = "/Login/Logout";
                                            }

                                        });
                                    }
                                    else {
                                        window.location.href = "/Login/Logout";
                                    }
                                    break;
                            }
                        },
                    },
                },
            ],
        };
    }

    function titleTemplate(itemData, itemIndex, itemElement) {
        let $icon = $('<i data-bind="html: $data">');

        if (itemData.iconClass) {
            $icon.addClass(itemData.iconClass);
        }
        else {
            $icon.addClass("ms");
        }

        ko.applyBindings(itemData.icon, $icon[0]);
        itemElement.append($icon);

        let $span = $(`<span data-bind="text: $data"></span>`);
        ko.applyBindings(itemData.title, $span[0]);
        itemElement.append($span);
    }
}

//editing-buttons-toolbar